// component
import Component from '@/components/Component';

// constants
import { DOCUMENT_ELEMENT, SELECTORS } from '@/scripts/constants';

// assets
import './MobileMenu.scss';

export class MobileMenu extends Component {
  _updateGeneralStatus() {
    const { active } = this._state;
    const { menuTriggers } = this._props;
    [SELECTORS.has_modal, SELECTORS.menu_opened].forEach((className) => {
      DOCUMENT_ELEMENT.classList.toggle(className, active);
    });
    [this._element, ...menuTriggers].forEach((item) => {
      item.classList.toggle(SELECTORS.active, active);
    });
  }
  _updateView() {
    this._updateGeneralStatus();
  }

  _setupEvents() {
    const { menuTriggers } = this._props;

    // general triggers
    menuTriggers.forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        this._setState({
          active: !this._state.active,
        });
      });
    });
  }

  init() {
    super.init();
    this._setupEvents();
  }
}
